import React, { useState } from "react";
import styled from '@emotion/styled';
import { GatsbyImage, getImage, withArtDirection,getSrc } from "gatsby-plugin-image";
import { useStaticQuery, graphql } from "gatsby"
import RoundButton from '../../../components/RoundButton'
import AnimatedSection from '../../../components/AnimatedSection';
import { useLocalization } from "gatsby-theme-i18n";
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { isAutoEmbedAllowed } from '../../../functions/common';
import VideoModal from '../../../components/VideoModal';

const IngameItemSection = () => {

  const data = useStaticQuery(graphql`
    query IngameItemSection {
      background: file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_inGameItem.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      background_mobile: file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_inGameItem_mobile.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      video_thumbnail: file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "content/visual_inGameItems.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      btn_play: file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/btn_play.png"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
    }
  `);

  const { t, currentLocaleObj, locale } = useLocalization();
  const [toggler, setToggler] = useState(false);

  return(
    <SectionWrapper>
      <ContentWrapper>
        <AnimatedSection>
          <Content>
            <VideoThumbnail playbtn={getSrc(data.btn_play)} onClick={(e) => {
              if(isAutoEmbedAllowed() || locale === "ja")
              {
                e.preventDefault();
                setToggler(!toggler);
              } 
            }} href={t('ingame_item.mount.movie.url')} target="_blank" rel="canonical noreferrer noopener">
            <GatsbyImage image={getImage(data.video_thumbnail)} alt={t('home.ingame_item.title')} />
            </VideoThumbnail>
            <Text>
              <span>{t('home.ingame_item.label')}</span>
              <span>{t('home.ingame_item.title')}</span>
              <ButtonContainer>
                <RoundButton fade to={`/${currentLocaleObj.prefix}/ingame-item/`} size={'medium'} fixedwidth="true" color={'#F50057'}>
                  {t('home.ingame_item.button.label')}
                </RoundButton>
              </ButtonContainer>
            </Text>
          </Content>
        </AnimatedSection>
        <Background>

        <GatsbyImage image={
          withArtDirection(getImage(data.background), [
            {
              media: `(min-width: ${breakpoint.smMin})`,
              image: getImage(data.background),
            },
            {
              media: `(max-width: ${breakpoint.xsMax})`,
              image: getImage(data.background_mobile),
            }
          ])} alt="background" objectFit={'contain'} />
        </Background>
      </ContentWrapper>
      {toggler &&
        <VideoModal id={t('ingame_item.mount.movie.url').split('?v=').pop()} onClose={() => setToggler(false)} title={t('home.ingame_item.title')} />
      }
      {/*<FsLightbox
        toggler={toggler}
        maxYoutubeVideoDimensions={{ width: 928, height: 528}}
        sources={[t('ingame_item.mount.movie.url')]}
        />*/}
    </SectionWrapper>
  );
}

export default IngameItemSection;

const SectionWrapper = styled.div`
  background: linear-gradient(180deg, #ECECEF 0%, #F7F7FA 100%);
  
`
const ContentWrapper = styled.div`
  border-radius: 6px;
  position:relative;
  height:560px;
  @media only screen and (max-width: ${breakpoint.smMax}){
    height:304px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    height:auto;
    padding:32px 0 0;
  }
`

const Background = styled.div`
  height:560px;
  width:861px;
  position:absolute;
  top:0;
  right:0;

  @media only screen and (max-width: ${breakpoint.smMax}){
    height:304px;width:467px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    height:auto;width:100%;
    top:auto;
    bottom:0;
    right:0;
  }
  
`

const Content = styled.div`
  display:flex;
  width:1440px;
  margin:0 auto;
  position:relative;
  z-index:2;
  align-items:center;
  height:560px;
  padding:0 48px;
  max-width:100%;
  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:0 80px;
    height:304px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:0 24px;
    height:auto;
    flex-wrap:wrap;
  }
`

const VideoThumbnail = styled.a`
  display:block;
  width:calc(50% - 24px);
  height:auto;
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 12px;
  z-index:1;
  position:relative;
  overflow:hidden;
  cursor: pointer;
  &:before{
    content:' ';
    position: absolute;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;

    background: rgba(0, 0, 0, 0.3);
    background-blend-mode: darken;
    box-shadow: inset 0px 0px 64px rgba(0, 0, 0, 0.25);
    z-index:2;
  }

  &:after{
    content:' ';
    position: absolute;
    left:50%;
    top:50%;
    width:191px;
    height:153px;
    transform:translate(-50%,-50%);
    background:url(${props => props.playbtn}) no-repeat;
    background-size:100%;
    z-index:3;
  }
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:calc(50% - 16px);
    &:after{
      width:86px;
      height:70px;
    }
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:100%;
  }
`

const Text = styled.div`
  padding:0 48px;
  > span{
    display:block;
    &:nth-of-type(1){
      font-weight: 900;
      font-size: 24px;
      line-height: 32px;
      letter-spacing: 0.05em;
      color: #D00F31;
      margin-bottom:16px;
    }

    &:nth-of-type(2){
      font-weight: 900;
      font-size: 48px;
      line-height: 56px;
      letter-spacing: 0.05em;
      color: #2C2C2E;
    }
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:0 0px 0 32px;
    > span{
      &:nth-of-type(1){
        font-size: 12px;
        line-height: 16px;
        margin-bottom:4px;
      }
      &:nth-of-type(2){
        font-size: 24px;
        line-height: 32px;
      }
    }
  } 

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:32px 0 26px;
    width:100%;
    text-align:center;
    > span{
      &:nth-of-type(1){
        font-size: 10px;
        line-height: 14px;
        margin-bottom:0px;
      }
      &:nth-of-type(2){
        font-size: 20px;
        line-height: 28px;
      }
    }
  }
`

const ButtonContainer = styled.div`
  margin-top:32px;
  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-top:24px;
  }
`
